import { faXmark } from "@fortawesome/pro-light-svg-icons";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/base-components/Icon";
import { NodeIcon as getNodeIcon } from "src/constants/NodeIcons";
import {
  ADD_NODE_GROUP_PROPERTIES,
  CREATABLE_NODE_PROPERTIES,
  getNodeTitle,
} from "src/constants/NodeProperties";
import { ADD_NODES_GROUPS, AddNodeGroupType } from "src/constants/NodeTypes";
import { rightSidePaneWidthClassname } from "src/flowContainer/RightPane";
import { AddNodeCard } from "src/nodeAdding/AddNodeCard";
import { AddNodeParams } from "src/store/GraphStore";

export type AddNodeGroupPaneProps = {
  addNode: (params: AddNodeParams) => void;
  groupType: AddNodeGroupType;
  onBackButtonClick: () => void;
  onCloseButtonClick: () => void;
};

export const AddNodeGroupPane: React.FC<AddNodeGroupPaneProps> = ({
  addNode,
  onCloseButtonClick,
  onBackButtonClick,
  groupType,
}) => {
  const nodes = ADD_NODES_GROUPS[groupType];
  return (
    <div className={twJoin("bg-white px-4 pt-4", rightSidePaneWidthClassname)}>
      <div className="mb-4 flex flex-row items-center justify-between text-gray-800">
        <div className="flex">
          <Icon
            color="text-gray-500 hover:text-gray-700 hover:cursor-pointer"
            icon={faArrowLeft}
            size="xs"
            onClick={onBackButtonClick}
          />
          <div className="ml-2 font-inter-semibold-16px">
            {ADD_NODE_GROUP_PROPERTIES[groupType].HEADER}
          </div>
        </div>
        <Icon
          color="text-gray-500 hover:text-gray-700 hover:cursor-pointer"
          icon={faXmark}
          size="xs"
          onClick={onCloseButtonClick}
        />
      </div>
      <div>
        {nodes.map((node) => (
          <AddNodeCard
            description={CREATABLE_NODE_PROPERTIES[node].ADD_BUTTON_DESCRIPTION}
            infoBody={CREATABLE_NODE_PROPERTIES[node].INFO_BODY}
            infoTitle={CREATABLE_NODE_PROPERTIES[node].INFO_TITLE}
            isBeta={CREATABLE_NODE_PROPERTIES[node].IS_BETA}
            nodeIcon={getNodeIcon({ nodeType: node })}
            title={getNodeTitle({ nodeType: node })}
            onClick={() => addNode({ nodeType: node })}
          />
        ))}
      </div>
    </div>
  );
};
